import React, { createContext, useContext, useEffect, useState } from 'react';
import socketService from '../services/socket';


const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [socketId, setSocketId] = useState(null);
  const [lastEvent, setLastEvent] = useState(null);

useEffect(() => {
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const userRole =
    localStorage.getItem("userRole") ||
    localStorage.getItem("userType");

  if (!token || !userId || !userRole) {
    console.log("⏳ No auth yet, socket not connected");
    return;
  }

  console.log("🚀 Connecting socket ONCE:", userId, userRole);

  // ✅ Prevent duplicate connections
  if (!socketService.socket || !socketService.socket.connected) {
    socketService.connect(userId, userRole);
  }

  const socket = socketService.socket;
  if (!socket) return;

  // ✅ Clear old listeners first (VERY IMPORTANT)
  socket.off("connect");
  socket.off("disconnect");

  socket.on("connect", () => {
    console.log("🟢 Socket connected:", socket.id);
    setIsConnected(true);
    setSocketId(socket.id);
  });

  socket.on("disconnect", () => {
    console.log("🔴 Socket disconnected");
    setIsConnected(false);
    setSocketId(null);
  });

  return () => {
    console.log("🛑 Cleaning up socket listeners");

    socket.off("connect");
    socket.off("disconnect");
  };
}, []);

  const value = {
  socket: socketService.socket, // ✅ REAL socket
  isConnected,
  socketId,
  lastEvent,
  clearLastEvent: () => setLastEvent(null)
};

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};